// @martyrs/src/modules/auth/views/plugins/authPlugin.js
import { reactive, defineComponent, h, render, defineAsyncComponent, nextTick } from 'vue';

// Dynamic import for better tree shaking and lazy loading
const PopupAuth = defineAsyncComponent(() =>
  import('@martyrs/src/modules/auth/views/components/blocks/PopupAuth.vue')
);

// 1) Общее состояние и API
const state = reactive({
  shouldRender: false,  // контролирует рендеринг компонента
  visible: false,       // контролирует анимацию
  title: '',
  subtitle: '',
  buttonText: '',
  returnUrl: '',
  resolve: null,
  reject: null
});

export function showAuth({
  title = '',
  subtitle = '',
  buttonText = '',
  returnUrl = ''
} = {}) {
  return new Promise((res, rej) => {
    state.resolve = res;
    state.reject = rej;
    state.title = title;
    state.subtitle = subtitle;
    state.buttonText = buttonText;
    state.returnUrl = returnUrl;
    state.shouldRender = true;
    nextTick(() => { state.visible = true; });
  });
}

export function closeAuth(result = null) {
  state.visible = false;
  state.resolve?.(result);
  state.resolve = state.reject = null;
}

export function cancelAuth() {
  state.visible = false;
  state.reject?.(new Error('Authentication cancelled'));
  state.resolve = state.reject = null;
}

function onAfterLeave() {
  state.shouldRender = false;
}

// 2) Хост-компонент
const AuthDialogHost = defineComponent({
  name: 'AuthDialogHost',
  setup() {
    return () => {
      if (!state.shouldRender) return null;

      return h(PopupAuth, {
        authState: state,
        closeAuth: closeAuth,
        'onClose-popup': cancelAuth,
        'onAfter-leave': onAfterLeave
      });
    };
  }
});

// 3) Плагин
export default {
  install(app) {
    // 3.1) Глобальный метод
    app.config.globalProperties.$auth = showAuth;
    app.config.globalProperties.$showAuth = showAuth;
    
    // 3.2) Контейнер в body
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const container = document.createElement('div');
      container.id = 'auth-dialog-host';
      document.body.appendChild(container);
      
      // 3.3) Рендерим VNode в контексте основного app
      const vnode = h(AuthDialogHost);
      vnode.appContext = app._context;    // <-- ключевой момент
      render(vnode, container);
    }
  }
};